var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.207,
    height: 18.584,
    viewBox: "0 0 17.207 18.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61621"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44227",
    d: "M-4503.925-3738.76v-.934h-12.163a1.431 1.431 0 0 1-1.543-1.328c.152-.011.3-.031.446-.032q4.816-.03 9.632-.057a2.853 2.853 0 0 0 2.9-2.174 3.6 3.6 0 0 0 .088-.846c.009-1.463.005-2.926 0-4.389 0-.6-.128-.731-.729-.728l-11.729.072h-.633v-1.634a1.635 1.635 0 0 0-1.791-1.817c-.554-.005-1.109 0-1.685 0v.936h1.574c.771 0 .968.2.968.96v9.4a2.39 2.39 0 0 0 2.564 2.573h12.1z",
    transform: "translate(4521.132 3752.63)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44228",
    d: "M-4501.856-3686.143a1.915 1.915 0 0 0 1.9 1.939 1.917 1.917 0 0 0 1.919-1.921 1.918 1.918 0 0 0-1.92-1.921 1.918 1.918 0 0 0-1.899 1.903z",
    transform: "translate(4506.256 3702.787)",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44229",
    d: "M-4465.881-3686.145a1.915 1.915 0 0 0 1.9 1.938 1.936 1.936 0 0 0 1.928-1.92 1.937 1.937 0 0 0-1.89-1.919 1.919 1.919 0 0 0-1.938 1.901z",
    transform: "translate(4478.493 3702.788)",
    style: {
      opacity: 0.6
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.72d82508e9933a755cc08f3f6c7e43bf.svg";
export { ForwardRef as ReactComponent };